import React from 'react';
import './log.css';
import Admin from '../images/admin.jpeg'
import admn from '../images/profile.jpeg'
import { Link } from 'react-router-dom';

const Card = () => {
  return (
    <div className="carding">
      <div className="card-sectionn">
        <div className="profile-container">
          <img src={Admin} alt="Admin Profile" className="profile-picture" />
          <div className="profile-text">Login as Admin</div>
        </div>
        <Link to='/loginadmin'>
        <button className="btnnon">Admin</button>
        </Link>
      </div>
      <div className="divider"></div>
      <div className="card-sectionn">
        <div className="profile-container">
          <img src={admn} alt="Client Profile" className="profile-picture" />
          <div className="profile-text">Login as Client</div>
        </div>
        <Link to='/login'>
        <button className="btnnon">Client</button>
        </Link>
      </div>
    </div>
  );
};

export default Card;